import * as React from "react";
import { useParams } from "react-router-dom";
import {
  Typography,
  Card,
  Stack,
  Button,
  Chip,
  Divider,
  FormHelperText,
  TextField,
  Box,
} from "@mui/material";
import { Loader } from "../../../shared";
import InputControl from "../../../shared/components/InputControl";
import SimpleReactValidator from "simple-react-validator";
import { useSettings } from "../../Settings/hooks";
import { AsyncPaginate } from "react-select-async-paginate";
import AddIcon from "@mui/icons-material/Add";
import { Link, useNavigate } from "react-router-dom";
import { errorMessage } from "../../../utils";

export const OnlineOrderingSettings = () => {
  const { id } = useParams();
  const {
    state,
    globalData,
    HandleInputChange,
    onUpdateSettings,
    handleAddMaIL,
    handleDeleteMaIL,
    handleGetUserList,
    stateTemplates,
    handleOnChange,
  } = useSettings(id);
  const { isLoading, details, isSaveButton } = state;
  const optionsTemplate = globalData?.eod_template?.map((item) => ({
    label: item.label,
    value: item.value,
  }));
  const navigate = useNavigate();
  const [input, setInput] = React.useState();
  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );
  const validator2 = React.useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );

  const {
    variance_status,
    eod_variance,
    auto_log_status,
    auto_log_time,
    email,
    float_amount,
    keypad_id,
    pre_order_days,
    delivery_radius,
    delivery,
    delivery_provider,
    eod_template,
    cart_product_count_limit,
    cart_product_waiting_time_limit,
    local_kds,
    dt_pick_up_available,
  } = details;
  const optionTemplates = stateTemplates?.templates?.map((item) => ({
    label: item.name,
    value: item.id,
  }));

  const onSubmit = () => {
    if (validator.current.allValid()) {
      onUpdateSettings();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  const onADD = () => {
    if (validator2.current.allValid()) {
      if (email.some((v) => v.email === input)) {
        errorMessage("This email already exist.");
        setInput("");
        validator2.current.hideMessages();
      } else {
        handleAddMaIL(input);
        setInput("");
        validator2.current.hideMessages();
      }
    } else {
      validator2.current.showMessages();
      forceUpdate(1);
    }
  };

  const onInputChange = (inputValue, { action }) => {
    if (action === "input-change") {
      setInput(inputValue);
    }
  };

  const CustomOption = (props) => {
    const { data, innerRef, innerProps, isSelected } = props;
    return (
      <>
        {data.custom ? (
          <Stack
            ref={innerRef}
            {...innerProps}
            sx={{
              flexDirection: "row",
              p: "7px 8px",
              gap: "2px",
              alignItems: "center",
            }}
          >
            <AddIcon
              sx={{
                color: "#1560D4",
              }}
            />

            <Link
              target="_blank"
              sx={{ textDecoration: "none" }}
              onClick={() => navigate("/client-account/customer/create")}
            >
              Add new User
            </Link>
          </Stack>
        ) : (
          <Stack
            ref={innerRef}
            {...innerProps}
            sx={{
              flexDirection: "row",

              p: "7px 8px",

              gap: "2px",
            }}
          >
            <Stack
              sx={{
                gap: "2px",
              }}
            >
              <Typography
                variant="subtitle2"
                fontWeight={400}
                lineHeight="17px"
              >
                {data.name}
              </Typography>
              <Typography color="#666666" variant="caption" lineHeight="15px">
                {data.email}
              </Typography>
            </Stack>
          </Stack>
        )}
      </>
    );
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "8px",
      border: "2px solid #E6E8F0",
      height: "48px",
    }),
    option: (provided, state) => ({
      ...provided,
      maxHeight: "239px",
    }),
    menu: (provided, state) => ({
      ...provided,
      zIndex: 99,
    }),
  };
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {validator.current.purgeFields()}
          <Card sx={{ mb: "230px", overflow: "inherit" }}>
            <Stack
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                p: "24px",
              }}
            >
              <Typography
                variant="subtitle1"
                fontWeight={600}
                lineHeight="19px"
                minWidth="200px"
              >
                Settings
              </Typography>
              <Button
                type="button"
                size="medium"
                variant="contained"
                onClick={onSubmit}
                disabled={isSaveButton}
              >
                Save
              </Button>
            </Stack>
            <Divider />
            <Stack direction="row" p="24px" alignItems="center">
              <Typography
                variant="subtitle1"
                fontWeight={600}
                lineHeight="19px"
                minWidth="200px"
              >
                Drive Through Online Order Collection
              </Typography>
              <Stack
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    gap: "16px",
                  }}
                >
                  <InputControl
                    type="switch"
                    name="dt_pick_up_available"
                    value={dt_pick_up_available}
                    onChange={(e) => {
                      HandleInputChange({
                        target: {
                          name: "dt_pick_up_available",
                          value: e.target.checked ? 1 : 0,
                        },
                      });
                    }}
                  />
                </Stack>
              </Stack>
            </Stack>
            <Divider />
            <Stack direction="row" p="24px">
              <Typography
                variant="subtitle1"
                fontWeight={600}
                lineHeight="19px"
                minWidth="200px"
              >
                Delivery Available
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <InputControl
                  type="switch"
                  name="variance_status"
                  value={delivery}
                  onChange={(e) =>
                    HandleInputChange({
                      target: {
                        name: "delivery",
                        value: e.target.checked ? 1 : 0,
                      },
                    })
                  }
                />
                <Stack
                  sx={{
                    width: "100%",
                    gap: "16px",
                  }}
                  mt={2}
                >
                  <Stack
                    sx={{
                      flexDirection: "row",
                      gap: "16px",
                    }}
                  >
                    <>
                      <InputControl
                        type="dropdown"
                        name="delivery_provider"
                        disableClearable
                        options={
                          globalData?.delivery_provider_customerApp ?? []
                        }
                        filteredOptions
                        getOptionLabel={(option) => option?.label}
                        onChange={(e, newValue) => {
                          handleOnChange(newValue, "delivery_provider");
                        }}
                        value={
                          (globalData?.delivery_provider_customerApp?.length >
                            0 &&
                            delivery_provider &&
                            globalData?.delivery_provider_customerApp?.find(
                              (c) => c.value === delivery_provider
                            )) ||
                          null
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            sx={{
                              borderRadius: "8px",
                              ".MuiInputBase-root": { height: "44px" },
                            }}
                            label="Provider"
                            required={delivery === 1}
                            error={
                              delivery === 1 &&
                              validator.current.message(
                                "Provider",
                                delivery_provider,
                                "required"
                              )
                            }
                            helperText={
                              delivery === 1 &&
                              validator.current.message(
                                "Provider",
                                delivery_provider,
                                "required"
                              )
                            }
                          />
                        )}
                      />
                      <InputControl
                        label="Radius (km)"
                        type="number"
                        name="delivery_radius"
                        value={delivery_radius}
                        onChange={HandleInputChange}
                        required={delivery === 1}
                        error={
                          delivery === 1 &&
                          validator.current.message(
                            "Radius (km)",
                            delivery_radius,
                            "required"
                          )
                        }
                        helperText={
                          delivery === 1 &&
                          validator.current.message(
                            "Radius (km)",
                            delivery_radius,
                            "required"
                          )
                        }
                      />
                    </>
                  </Stack>
                </Stack>
              </Box>
            </Stack>
            <Divider />
            <Stack direction="row" p="24px">
              <Typography
                variant="subtitle1"
                fontWeight={600}
                lineHeight="19px"
                minWidth="200px"
              >
                Pre Order Days
              </Typography>
              <Stack
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    gap: "16px",
                  }}
                >
                  <InputControl
                    label="Days"
                    type="number"
                    name="pre_order_days"
                    value={pre_order_days}
                    onChange={HandleInputChange}
                  />
                </Stack>
              </Stack>
            </Stack>
            <Divider />
            <Stack direction="row" p="24px">
              <Typography
                variant="subtitle1"
                fontWeight={600}
                lineHeight="19px"
                minWidth="200px"
              >
                Cart Quantity Threshold
              </Typography>
              <Stack
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    gap: "16px",
                  }}
                >
                  <InputControl
                    label="Product Count"
                    type="number"
                    name="cart_product_count_limit"
                    value={cart_product_count_limit}
                    onChange={HandleInputChange}
                    required
                    error={
                      validator.current.message(
                        "Product Count",
                        cart_product_count_limit,
                        "required"
                      )
                    }
                    helperText={
                      validator.current.message(
                        "Product Count",
                        cart_product_count_limit,
                        "required"
                      )
                    }
                  />
                  <InputControl
                    label="Waiting Time(In minutes)"
                    type="number"
                    name="cart_product_waiting_time_limit"
                    value={cart_product_waiting_time_limit}
                    onChange={HandleInputChange}
                    required
                    error={
                      validator.current.message(
                        "Waiting Time(In minutes)",
                        cart_product_waiting_time_limit,
                        "required"
                      )
                    }
                    helperText={
                      validator.current.message(
                        "Waiting Time(In minutes)",
                        cart_product_waiting_time_limit,
                        "required"
                      )
                    }
                  />
                </Stack>
              </Stack>
            </Stack>
            <Divider />

            {/* <Stack direction="row" p="24px">
              <Typography
                variant="subtitle1"
                fontWeight={600}
                lineHeight="19px"
                minWidth="200px"
              >
                Online Ordering Cut off
                Time
              </Typography>
              <Stack
                sx={{
                  width: "100%",
                  gap: "16px",
                }}
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    gap: "16px",
                  }}
                >
                  <InputControl
                    label="Product Count"
                    type="number"
                    name="cart_product_count_limit"
                    value={cart_product_count_limit}
                    onChange={HandleInputChange}
                    required
                    error={
                      validator.current.message(
                        "Product Count",
                        cart_product_count_limit,
                        "required"
                      )
                    }
                    helperText={
                      validator.current.message(
                        "Product Count",
                        cart_product_count_limit,
                        "required"
                      )
                    }
                  />
                </Stack>
              </Stack>
            </Stack> */}
          </Card>
        </>
      )}
    </>
  );
};
